<ng-container [formGroup]="orderEditingService.form.get('template.repricing')">
  <pdq-card variant="flat" color="white">
    <div class="card-container">
      <div class="card-body">
        <pdq-slide-toggle
          togglePosition="right"
          label="Show Order Editing extension"
          subtext="Allow customers to edit their orders"
          [formControl]="orderEditingService.form.get('template.edits.isDisplayed')">
        </pdq-slide-toggle>
      </div>
    </div>
  </pdq-card>
  <pdq-card variant="flat" color="white">
    <div class="card-container">
      @let isItemRemovalAllowed = orderEditingService.form.get('template.repricing.itemRemovalAdjustment').value;
      <div class="card-header" [class.collapsed]="!isItemRemovalAllowed">
        <div class="header-content">
          <pdq-heading element="h6">Allow item removal</pdq-heading>
          <span class="header-subtext">Customers can remove items from their order.</span>
        </div>
        <pdq-slide-toggle formControlName="itemRemovalAdjustment"></pdq-slide-toggle>
      </div>
      @if (isItemRemovalAllowed) {
        <pdq-divider></pdq-divider>
        <div class="refund-handling-body">
          <order-editing-form-refund-handling
            [refundHandlingTypeControl]="
              orderEditingService.form.get('template.repricing.itemRemovalRefundHandlingType')
            "
            automaticRefundOptionText="Refund removed items automatically once the window closes"></order-editing-form-refund-handling>
        </div>
      }
    </div>
  </pdq-card>
  <pdq-card variant="flat" color="white">
    <div class="card-container">
      <div class="card-body">
        <pdq-radio-group
          secondaryLabel="Define what happens when the customer does not pay for all changes before the edit window closes"
          formControlName="unpaidChangesHandlingType"
          label="Unpaid Edits Handling">
          <pdq-radio-button
            [value]="UnpaidChangesHandlingType.ROLLBACK_TO_PAID_STATE"
            [checked]="
              orderEditingService.form.get('template.repricing.unpaidChangesHandlingType').value ===
              UnpaidChangesHandlingType.ROLLBACK_TO_PAID_STATE
            "
            text="Roll back unpaid changes to the last paid state once the window closes">
          </pdq-radio-button>
          <pdq-radio-button
            [value]="UnpaidChangesHandlingType.CONTINUE_PARTIALLY_PAID"
            [checked]="
              orderEditingService.form.get('template.repricing.unpaidChangesHandlingType').value ===
              UnpaidChangesHandlingType.CONTINUE_PARTIALLY_PAID
            "
            text="Keep unpaid changes in the customer’s order">
          </pdq-radio-button>
        </pdq-radio-group>
      </div>
    </div>
  </pdq-card>
  <!-- Shopify Flow mode places no PDQ hold. -->
  @if (!orderEditingService.useShopifyFlows) {
    <pdq-card variant="flat" color="white">
      <div class="card-container">
        <div class="card-body">
          <pdq-radio-group
            secondaryLabel="Define which fulfillment holds are released when the edit window closes"
            [formControl]="orderEditingService.form.get('template.settings.fulfillmentHoldReleaseMode')"
            label="Fulfillment Hold Release">
            <pdq-radio-button
              [value]="FulfillmentHoldReleaseMode.ALL_HOLDS"
              [checked]="
                orderEditingService.form.get('template.settings.fulfillmentHoldReleaseMode').value ===
                FulfillmentHoldReleaseMode.ALL_HOLDS
              "
              text="Release all holds, including those from other apps">
            </pdq-radio-button>
            <pdq-radio-button
              [value]="FulfillmentHoldReleaseMode.PDQ_HOLDS_ONLY"
              [checked]="
                orderEditingService.form.get('template.settings.fulfillmentHoldReleaseMode').value ===
                FulfillmentHoldReleaseMode.PDQ_HOLDS_ONLY
              "
              text="Release only holds placed by PDQ">
            </pdq-radio-button>
          </pdq-radio-group>
        </div>
      </div>
    </pdq-card>
  }
  <!-- <pdq-card variant="flat" color="white" [formGroupName]="'taxAdjustments'">
    <div class="card-container">
      <div class="card-header">
        <pdq-slide-toggle
          formControlName="enabled"
          togglePosition="right"
          label="Tax Adjustment Rules"
          subtext="Control how tax changes are handled when order edits affect taxable amounts"></pdq-slide-toggle>
      </div>
      <div class="card-body">
        <pdq-radio-group formControlName="type">
          @for (option of taxAdjustmentTypeOptions; track option.value) {
            <pdq-radio-button
              [checked]="option.value === orderEditingService.form.get('template.repricing.taxAdjustments.type').value"
              [value]="option.value"
              [text]="option.text"></pdq-radio-button>
          }
        </pdq-radio-group>
      </div>
    </div>
  </pdq-card> -->
</ng-container>
